import { useRef, useState } from "react";
import EditIcon from "../../../assets/icons/EditIcon";
import {
  Container,
  IconDiv,
  LogoZaivu,
  ProjectName,
  Input,
  ContentName,
  CheckButton,
} from "./styles";
import LogoZaivuWhite from "../../../assets/Logo-Zaivu-White.svg";
import PushBackIcon from "../../../assets/icons/PushBackIcon";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { toastAlert } from "../../../components/Toastify";
import { handleRenameActivedFlow } from "../../../state/activedFlows/actions";
import { ProtectedComponent } from "../../../components/general/Protected";
import { debounce } from "lodash";
import Check from "../../../assets/icons/Check";

export default function DropSelectWorkflow({
  user,
  title = "",
  setTitle,
  project,
}) {
  DropSelectWorkflow.propTypes = {
    title: PropTypes.string,
    setTitle: PropTypes.func,
    project: PropTypes.object,
    user: PropTypes.object,
  };

  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const clearInput = () => {
    setOpen(false);
  };
  const history = useHistory();

  const dispatch = useDispatch();

  // useOutsideDrop(wrapperRef, clearInput);

  const pushBackStyle = {
    height: "1.75rem",
    width: "1.75rem",
    marginLeft: "1.2rem",
    cursor: "pointer",
  };

  const handleRename = debounce(async () => {
    dispatch(
      handleRenameActivedFlow({
        title,
        flowId: project._id,
      })
    )
      .then(() => {
        toastAlert({
          msg: `Projeto RENOMEADO com Sucesso!`,
        });
      })
      .catch((err) => {
        toastAlert({
          msg: `ERRO ao renomear o fluxo '${title}': ${err} `,
          isError: true,
        });
        setTitle(project.title);
        console.log(err);
      });
  }, 300);

  const updateTitle = async () => {
    const isChangedTitle =
      title.trim() !== project.title.trim() && title.trim() !== "";
    if (isChangedTitle) {
      handleRename();
    } else {
      setTitle(project.title);
    }
    clearInput();
  };

  const toDisableButton =
    title.trim() !== project.title.trim() && title.trim() !== "";

  const editPermission = () => user.rank === "admin" || user.rank === "gerente";

  return (
    <Container style={{ cursor: "auto" }}>
      <PushBackIcon onClick={() => history.goBack()} style={pushBackStyle} />
      <LogoZaivu
        src={LogoZaivuWhite}
        style={{ cursor: "pointer" }}
        onClick={() => history.push("/")}
      />

      <ContentName ref={wrapperRef}>
        <ProjectName openInput={open} AdvancedStats>
          {!open ? (
            <>
              <p>{title}</p>
              <ProtectedComponent callback={editPermission}>
                <IconDiv
                  onClick={(event) => {
                    event.stopPropagation();
                    setOpen(true);
                  }}
                >
                  <EditIcon />
                </IconDiv>
              </ProtectedComponent>
            </>
          ) : (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Input
                maxLength="60"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <CheckButton onClick={updateTitle}>
                <Check
                  color={!toDisableButton ? "lightgray" : "#40e5a0"}
                  viewBox=""
                />
              </CheckButton>
            </div>
          )}
        </ProjectName>
      </ContentName>
    </Container>
  );
}
